import { render, staticRenderFns } from "./MarketingAutomation.vue?vue&type=template&id=5402861b&scoped=true&"
import script from "./MarketingAutomation.vue?vue&type=script&lang=js&"
export * from "./MarketingAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5402861b",
  null
  
)

export default component.exports